module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("There are two voices in this book, mine and my grandfather’s, William McCrae. William’s writing is at the heart of this account, and all his words are therefore in a contrasting font, in order that the reader can easily differentiate his narrative from my own. SB")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2163c7d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Ded1.vue
// module id = 69
// module chunks = 0